export default "__VITE_ASSET__64960529__"